import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1702265535311'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='8988'
    >
        <path d='M0 0h1024v1024H0z' fill='#FFFFFF' fillOpacity='.01' p-id='8989'></path>
        <path
            d='M256 170.666667a85.333333 85.333333 0 1 1-170.666667 0 85.333333 85.333333 0 0 1 170.666667 0zM597.333333 170.666667a85.333333 85.333333 0 1 1-170.666666 0 85.333333 85.333333 0 0 1 170.666666 0zM938.666667 170.666667a85.333333 85.333333 0 1 1-170.666667 0 85.333333 85.333333 0 0 1 170.666667 0zM938.666667 512a85.333333 85.333333 0 1 1-170.666667 0 85.333333 85.333333 0 0 1 170.666667 0zM938.666667 853.333333a85.333333 85.333333 0 1 1-170.666667 0 85.333333 85.333333 0 0 1 170.666667 0zM597.333333 853.333333a85.333333 85.333333 0 1 1-170.666666 0 85.333333 85.333333 0 0 1 170.666666 0zM256 853.333333a85.333333 85.333333 0 1 1-170.666667 0 85.333333 85.333333 0 0 1 170.666667 0zM256 512a85.333333 85.333333 0 1 1-170.666667 0 85.333333 85.333333 0 0 1 170.666667 0zM597.333333 512a85.333333 85.333333 0 1 1-170.666666 0 85.333333 85.333333 0 0 1 170.666666 0z'
            fill='currentColor'
            p-id='8990'
        ></path>
    </svg>
)

export const NinePointsIcon = props => <Icon component={SVG} {...props} />
